module.exports = __webpack_public_path__ + "img/get_wx_sub.4aef9cdb.png";